module.exports = __webpack_public_path__ + "img/Spinner-3.c0c00338.gif";